export default function PrivacyContent() {
  return (
    <section className="bg-white py-10 md:py-14">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-[1280px] mx-auto">
          {/* 1. Responsable du traitement */}
          <div className="mb-10 md:mb-12">
            <h2 className="font-serif text-xl md:text-2xl font-bold text-[#1E3A47] mb-4">
              1. Responsable du traitement
            </h2>
            <p className="text-[#243038] text-sm md:text-base leading-relaxed mb-3">
              Le responsable du traitement des données collectées sur le site DF PRO est :
            </p>
            <div className="bg-[#EEF2F4] rounded-2xl border border-[#D7E0E4] p-5 md:p-6">
              <p className="text-[#243038] text-sm md:text-base leading-relaxed">
                <strong className="text-[#1E3A47]">DF PRO</strong><br />
                Atelier : 82 rue de Heidenberg, 67200 Strasbourg<br />
                Téléphone : <a href="tel:0374471036" className="text-[#FF6B4A] hover:underline">03 74 47 10 36</a><br />
                Site : réparation de fenêtres dans le Bas-Rhin
              </p>
            </div>
          </div>

          {/* 2. Données collectées */}
          <div className="mb-10 md:mb-12">
            <h2 className="font-serif text-xl md:text-2xl font-bold text-[#1E3A47] mb-4">
              2. Données collectées
            </h2>
            <p className="text-[#243038] text-sm md:text-base leading-relaxed mb-3">
              Nous collectons uniquement les données nécessaires à votre demande de devis via le formulaire de contact :
            </p>
            <ul className="space-y-2 text-[#243038] text-sm md:text-base">
              <li className="flex items-start gap-2">
                <i className="ri-check-line text-[#FF6B4A] shrink-0 mt-0.5" />
                <span><strong>Nom</strong> — pour vous identifier lors de notre réponse</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-check-line text-[#FF6B4A] shrink-0 mt-0.5" />
                <span><strong>Téléphone</strong> — pour vous recontacter rapidement</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-check-line text-[#FF6B4A] shrink-0 mt-0.5" />
                <span><strong>E-mail</strong> — pour vous envoyer le devis si nécessaire</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-check-line text-[#FF6B4A] shrink-0 mt-0.5" />
                <span><strong>Code postal</strong> — pour localiser l'intervention</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-check-line text-[#FF6B4A] shrink-0 mt-0.5" />
                <span><strong>Message</strong> — pour comprendre votre problème de fenêtre</span>
              </li>
            </ul>
            <p className="text-[#243038] text-sm md:text-base leading-relaxed mt-4">
              Nous ne collectons pas de données bancaires, ni de numéros de carte de crédit. Le paiement éventuel se fait après intervention, sur place ou par virement, jamais via le site.
            </p>
          </div>

          {/* 3. Finalité du traitement */}
          <div className="mb-10 md:mb-12">
            <h2 className="font-serif text-xl md:text-2xl font-bold text-[#1E3A47] mb-4">
              3. Finalité du traitement
            </h2>
            <p className="text-[#243038] text-sm md:text-base leading-relaxed mb-3">
              Vos données sont collectées exclusivement pour :
            </p>
            <ul className="space-y-2 text-[#243038] text-sm md:text-base">
              <li className="flex items-start gap-2">
                <i className="ri-arrow-right-line text-[#1E3A47] shrink-0 mt-0.5" />
                <span>Répondre à votre demande de devis et de rendez-vous</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-arrow-right-line text-[#1E3A47] shrink-0 mt-0.5" />
                <span>Vous contacter par téléphone pour préciser l'intervention</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-arrow-right-line text-[#1E3A47] shrink-0 mt-0.5" />
                <span>Établir et vous transmettre le devis de réparation</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-arrow-right-line text-[#1E3A47] shrink-0 mt-0.5" />
                <span>Gérer le suivi de l'intervention à domicile</span>
              </li>
            </ul>
            <p className="text-[#243038] text-sm md:text-base leading-relaxed mt-4">
              Nous ne vous contacterons jamais à des fins de marketing, ni pour vous proposer des services non sollicités.
            </p>
          </div>

          {/* 4. Durée de conservation */}
          <div className="mb-10 md:mb-12">
            <h2 className="font-serif text-xl md:text-2xl font-bold text-[#1E3A47] mb-4">
              4. Durée de conservation
            </h2>
            <p className="text-[#243038] text-sm md:text-base leading-relaxed">
              Vos données personnelles sont conservées pendant la durée nécessaire au traitement de votre demande, puis archivées pendant <strong>3 ans maximum</strong> à compter du dernier contact. Passé ce délai, elles sont supprimées de manière sécurisée. Si vous souhaitez une suppression anticipée, contactez-nous au 03 74 47 10 36.
            </p>
          </div>

          {/* 5. Vos droits */}
          <div className="mb-10 md:mb-12">
            <h2 className="font-serif text-xl md:text-2xl font-bold text-[#1E3A47] mb-4">
              5. Vos droits (RGPD)
            </h2>
            <p className="text-[#243038] text-sm md:text-base leading-relaxed mb-3">
              Conformément au Règlement Général sur la Protection des Données (RGPD), vous disposez des droits suivants concernant vos données personnelles :
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              {[
                { title: "Droit d'accès", desc: "Obtenir une copie de vos données" },
                { title: "Droit de rectification", desc: "Corriger des informations inexactes" },
                { title: "Droit à l'effacement", desc: "Demander la suppression de vos données" },
                { title: "Droit d'opposition", desc: "Vous opposer au traitement" },
                { title: "Droit à la portabilité", desc: "Récupérer vos données dans un format standard" },
                { title: "Droit de limitation", desc: "Restreindre temporairement le traitement" },
              ].map((d) => (
                <div key={d.title} className="bg-[#EEF2F4] rounded-2xl border border-[#D7E0E4] p-4 md:p-5">
                  <h3 className="font-semibold text-[#1E3A47] text-sm md:text-base mb-1">{d.title}</h3>
                  <p className="text-[#243038] text-sm">{d.desc}</p>
                </div>
              ))}
            </div>
            <p className="text-[#243038] text-sm md:text-base leading-relaxed mt-4">
              Pour exercer ces droits, contactez-nous par téléphone au <a href="tel:0374471036" className="text-[#FF6B4A] hover:underline">03 74 47 10 36</a> ou envoyez-nous un courrier à l'adresse de l'atelier. Nous vous répondrons sous 30 jours maximum.
            </p>
          </div>

          {/* 6. Sécurité */}
          <div className="mb-10 md:mb-12">
            <h2 className="font-serif text-xl md:text-2xl font-bold text-[#1E3A47] mb-4">
              6. Sécurité des données
            </h2>
            <p className="text-[#243038] text-sm md:text-base leading-relaxed">
              Nous mettons en œuvre des mesures techniques et organisationnelles pour protéger vos données contre toute perte, accès non autorisé, altération ou divulgation. Le formulaire de contact inclut un champ anti-spam (honeypot) pour filtrer les soumissions automatisées.
            </p>
          </div>

          {/* 7. Cookies */}
          <div className="mb-10 md:mb-12">
            <h2 className="font-serif text-xl md:text-2xl font-bold text-[#1E3A47] mb-4">
              7. Cookies et mesure d'audience
            </h2>
            <p className="text-[#243038] text-sm md:text-base leading-relaxed mb-3">
              Notre site utilise des cookies de mesure d'audience (statistiques de visites) pour comprendre comment les utilisateurs naviguent et améliorer l'expérience. Ces cookies ne collectent pas de données personnelles identifiables.
            </p>
            <p className="text-[#243038] text-sm md:text-base leading-relaxed">
              Nous n'utilisons pas de cookies publicitaires, ni de traqueurs de réseaux sociaux. Aucune donnée n'est partagée avec des tiers à des fins de marketing ou de profilage.
            </p>
          </div>

          {/* 8. Hébergement */}
          <div className="mb-10 md:mb-12">
            <h2 className="font-serif text-xl md:text-2xl font-bold text-[#1E3A47] mb-4">
              8. Hébergement
            </h2>
            <p className="text-[#243038] text-sm md:text-base leading-relaxed">
              Le site DF PRO est hébergé sur la plateforme Readdy, qui assure la sécurité et la conformité RGPD des données hébergées. Les serveurs sont situés dans l'Union Européenne.
            </p>
          </div>

          {/* 9. Pas de revente */}
          <div className="mb-10 md:mb-12">
            <h2 className="font-serif text-xl md:text-2xl font-bold text-[#1E3A47] mb-4">
              9. Pas de cession ni de revente
            </h2>
            <p className="text-[#243038] text-sm md:text-base leading-relaxed">
              DF PRO s'engage à ne jamais vendre, louer, céder ou partager vos données personnelles avec des tiers, sauf obligation légale ou dans le cadre strict de la prestation de service (par exemple, si un sous-traitant intervient pour une réparation spécifique, avec votre accord préalable).
            </p>
          </div>

          {/* 10. Modification */}
          <div className="mb-10 md:mb-12">
            <h2 className="font-serif text-xl md:text-2xl font-bold text-[#1E3A47] mb-4">
              10. Modification de la politique
            </h2>
            <p className="text-[#243038] text-sm md:text-base leading-relaxed">
              Cette politique de confidentialité peut être mise à jour à tout moment pour refléter les évolutions législatives ou techniques. La date de dernière mise à jour est indiquée ci-dessous. Nous vous encourageons à la consulter régulièrement.
            </p>
          </div>

          {/* Date */}
          <div className="text-center pt-6 border-t border-[#D7E0E4]">
            <p className="text-[#243038]/60 text-sm">
              Dernière mise à jour : 29 mai 2026
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}